export const STORAGE_KEYS = {
  auth: "ims_auth_session",
  accessToken: "ims_auth_access_token",
  refreshToken: "ims_auth_refresh_token",
  theme: "ims_theme",
};

export const APP_COMPANY_NAME = "Ferrovan Global LLP";

export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB
export const MAX_FILE_SIZE_MB = 10;

export const ROLE_OPTIONS = [
  { label: "ADMIN", value: "ADMIN" },
  { label: "OPERATOR", value: "OPERATOR" },
  { label: "ACCOUNTANT", value: "ACCOUNTANT" },
];

export const DASHBOARD_METRICS = [
  { label: "Active SKUs", value: "1,248", change: "+8.2%" },
  { label: "Low Stock Alerts", value: "18", change: "-3.1%" },
  { label: "Pending POs", value: "27", change: "+12.4%" },
];
